<template>
<div>
    <Filters></Filters>

</div>
</template>


<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import Filters from './components/Filters.vue'
import {getParentId, createOverlay, removeOverlay} from '../plugins/utils';

export default{

    data(){
        return {
            sortElText: ''
        }
    },

    components: {
        Filters
    },

    computed: {
        ...mapGetters(['lng', 'dataRequest', "vesselsType"])
    },
    methods: {
        ...mapActions([
           'setLng',
           'setParentVesselsType',
           'setResultElement',
           'setPaginateElement',
           'prepareRequest',
           'sendRequest',
           'setLangLevels',
           'setCountries',
           'assignDataRequest',
           'setVesselsType',
           'setSal',
           'setRanks'

         ]),
         sortHandler(e){
             e.preventDefault();
            if(e.target.dataset.sort){
                this.prepareRequest({key: 'sort', val: e.target.dataset.sort});
                 this.sendRequest();
                 let text = '';
                 switch(e.target.dataset.sort) {
                    case 'salary':
                       text = "Salary";
                       break;
                    case 'duration':
                       text = "Duration";
                       break;
                    case 'joindate':
                       text = "Join date";
                       break;
                 }
                  this.sortElText.innerHTML = text
              }
         },
         paginateHandler(e){
            let isAjax = document.querySelector('#ajax-paginate');
            if(!isAjax){
                return;
            }
            e.preventDefault();
            let target = e.target;
            if(target.tagName.toLowerCase() !== 'a') {
                return;
            }

            let page = target.href.match(/.+page=([1-9][0-9]*)/i)[1];
            if(page) {
                this.prepareRequest({key: 'page', val: page});
                this.sendRequest();
            }



         }
    },

    mounted(){
           let filterPaginate = document.getElementById('filter-paginate');
           filterPaginate.addEventListener('click', this.paginateHandler, false);
            let el = document.getElementById('container-sort');
            this.sortElText = document.getElementById('sort-block-vacancy');
            el.addEventListener('click', this.sortHandler, false);

        },

    created(){
        axios.get(langUrl + "/filter/" + lang + ".json")
             .then(response => this.setLng(response.data));

       axios.post(url + '/vacancies', {
          action: 'getInitialData'
        }).then(response => {
            this.setParentVesselsType(response.data.parentVesselsType);
            this.setLangLevels(response.data.langList);
            this.setCountries(response.data.countries);
            this.setRanks(response.data.ranks);

        });

        if(typeof uid !== "undefined") {
             axios.post(url + '/vacancies', {
                       action: 'getFilter'
             }).
             then(response => {
                if(Object.keys(response.data.filter).length === 0) {
                    return;
                }
                this.assignDataRequest(response.data.filter);

                if(response.data.filter.hasOwnProperty('vessel')) {
                    this.setVesselsType(response.data.vessels);
                }


                this.prepareRequest({key: "action", val: 'getFilteredData'});
                this.sendRequest();
             });
        }

    }

}
</script>



// WEBPACK FOOTER //
// App.vue?6b847c9b